var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.importantNoticeData.title
    ? _c(
        "div",
        { staticClass: "notice-bar" },
        [
          _c("div", { staticClass: "notice-bar-left" }, [
            _c("span", { staticClass: "notice-bar-title" }, [
              _c("span", {
                staticClass: "iconfont icon-zhihuixiaofang-jingbaoguzhang",
              }),
              _vm._v(" " + _vm._s(_vm.$t("home.importantReminder")) + "："),
            ]),
            _c("div", { staticClass: "notice-bar-content" }, [
              _c("span", { staticClass: "marquee-text" }, [
                _vm._v(_vm._s(_vm.importantNoticeData.title)),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "notice-bar-btn", on: { click: _vm.handleView } },
            [_vm._v(_vm._s(_vm.$t("home.viewNow")))]
          ),
          _c("systemMessagePopUp", {
            ref: "systemMessagePopUpRef",
            on: { readMessage: _vm.onReadMessage },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }